<template>
  <div class="ChatCQU_sci">
    <comHeader
      :active="active"
      :value="value"
      style="background-color: rgba(49, 89, 161, 1)"
    ></comHeader>
    <div class="box">
      <div class="main_body">
        <div class="main_left">
          <div class="main_tit">
            <h2>输入</h2>
            <div
              class="btn_sea_ jour_s"
              v-if="corpus_or"
              style="position: relative; top: 5px; margin: 0 0 0 10px"
            >
              期刊范围:&ensp;<el-select
                size="small"
                style="width: 150px; text-align: center"
                v-model="corpus_val"
                placeholder="请选择"
                multiple
                collapse-tags
              >
                <el-option
                  v-for="item in corpus_list"
                  :key="item.code"
                  :label="item.tag"
                  :value="item.code"
                  :disabled="
                    corpus_val.length == 1 && corpus_val.indexOf(item.code) > -1
                  "
                  style="text-align: center"
                >
                </el-option>
              </el-select>
            </div>
          </div>

          <el-input type="textarea" :rows="5" v-model="textarea"> </el-input>
          <div class="search_type">
            <div>
              <el-radio v-model="radio" label="1" @input="search('1')"
                >摘要检索</el-radio
              >
              <el-radio v-model="radio" label="2" @input="search('1')"
                >全文检索</el-radio
              >
            </div>
            <div>
              <el-button type="text" @click="clearText">一键清空</el-button>
            </div>
          </div>
          <el-button
            class="submit_css"
            size="small"
            type="warning"
            @click="search()"
            >提交</el-button
          >
          <div class="sift_s" v-if="searchType !== '2' || radio === '1'">
            <div class="sift_box">
              <!-- <h3>年份</h3> -->
              <div class="sift_tit">
                <div class="tit">年份</div>
                <div class="sub" @click="sift_all">筛选</div>
              </div>
              <div
                class="sift_list"
                v-loading="loading"
                element-loading-text="加载中..."
                element-loading-spinner="el-icon-loading"
              >
                <el-checkbox-group v-model="cqu.year">
                  <el-checkbox
                    :label="item.key"
                    v-for="(item, index) in year_s"
                    :key="index"
                  >
                    <span
                      class="tooltip_span"
                      :title="
                        item.key +
                        `\xa0\xa0\xa0(\xa0` +
                        item.doc_count +
                        `\xa0)`
                      "
                    >
                      <span class="main">{{ item.key }}</span>
                      <span>({{ item.doc_count }})</span>
                    </span>
                  </el-checkbox>
                </el-checkbox-group>
              </div>
            </div>
            <div class="sift_box">
              <!-- <h3>学科</h3> -->
              <div class="sift_tit">
                <div class="tit">关键词</div>
                <div class="sub" @click="sift_all">筛选</div>
              </div>
              <div
                class="sift_list"
                v-loading="loading"
                element-loading-text="加载中..."
                element-loading-spinner="el-icon-loading"
              >
                <el-checkbox-group v-model="cqu.keyword">
                  <el-checkbox
                    :label="item.key"
                    v-for="(item, index) in keyword_s"
                    :key="index"
                  >
                    <span
                      class="tooltip_span"
                      :title="
                        item.key +
                        `\xa0\xa0\xa0(\xa0` +
                        item.doc_count +
                        `\xa0)`
                      "
                    >
                      <span class="main">{{ item.key }}</span>
                      <span>({{ item.doc_count }})</span>
                    </span>
                  </el-checkbox>
                </el-checkbox-group>
              </div>
            </div>
            <div class="sift_box">
              <div class="sift_tit">
                <div class="tit">作者</div>
                <div class="sub" @click="sift_all">筛选</div>
              </div>
              <div
                class="sift_list"
                v-loading="loading"
                element-loading-text="加载中..."
                element-loading-spinner="el-icon-loading"
              >
                <el-checkbox-group v-model="cqu.author">
                  <el-checkbox
                    :label="item.key"
                    v-for="(item, index) in author_s"
                    :key="index"
                  >
                    <span
                      class="tooltip_span"
                      :title="
                        item.key +
                        `\xa0\xa0\xa0(\xa0` +
                        item.doc_count +
                        `\xa0)`
                      "
                    >
                      <span class="main">{{ item.key }}</span>
                      <span>({{ item.doc_count }})</span>
                    </span>
                  </el-checkbox>
                </el-checkbox-group>
              </div>
            </div>
          </div>
        </div>
        <div
          class="main_right"
          v-loading="loading"
          element-loading-text="加载中..."
          element-loading-spinner="el-icon-loading"
        >
          <div class="data_list">
            <div v-if="radio === '2'" class="showType_">
              <span
                @click="search('1')"
                :style="{ color: searchType === '1' ? '#e6a23c' : '' }"
                >按文章显示</span
              >
              <span
                @click="search('2', 'same')"
                style="margin-left: 15px"
                :style="{ color: searchType === '2' ? '#e6a23c' : '' }"
                >按段落显示</span
              >
            </div>
            <!-- 按文章显示 -->
            <div v-if="searchType === '1'">
              <div
                class="data_txt"
                v-for="(item, index) in list_data"
                :key="index"
              >
                <div class="txt_top">
                  <div class="txt_s">
                    <h3 style="word-break: break-all">{{ item.title }}</h3>
                    <p v-if="item.author && item.author.length > 0">
                      <span style="font-weight: 600; font-size: 16px"
                        >作者:
                      </span>
                      <span
                        v-for="(item_aut, index_) in item.author"
                        :key="index_"
                        >{{ item_aut }}
                        <span v-if="index_ + 1 < item.author.length"> ; </span>
                      </span>
                    </p>
                    <p v-if="item.keyword && item.keyword.length > 0">
                      <span style="font-weight: 600; font-size: 16px"
                        >关键词:
                      </span>
                      <span
                        v-for="(item_word, index__) in item.keyword"
                        :key="index__"
                        >{{ item_word }}
                        <span v-if="index__ + 1 < item.keyword.length">
                          ;
                        </span>
                      </span>
                    </p>
                    <p>
                      <span style="margin: 0 0 0 0px" v-if="item.year">
                        <span style="font-weight: 600; font-size: 16px"
                          >年份: </span
                        >{{ item.year }}</span
                      >
                      <span style="margin: 0 0 0 30px" v-if="item.doi">
                        <span style="font-weight: 600; font-size: 16px"
                          >DOI:
                        </span>
                        <!-- https://doi.org/ -->
                        <span class="doi_css" @click="doi_url(item.doi)"
                          >{{ item.doi }} <i class="el-icon-top-right"></i
                        ></span>
                      </span>
                      <!-- v-if="item.source" -->
                      <span style="margin: 0 0 0 30px" >
                        <span style="font-weight: 600; font-size: 16px"
                          >来源:
                        </span>
                        <span class="doi_css">{{ item.source }}</span>
                      </span>
                    </p>
                  </div>
                </div>
                <div class="abstract_css" v-if="item.abstract">
                  <span style="font-weight: 600; font-size: 16px">摘要: </span>
                  <span v-if="item.abstract_show"
                    >{{ item.abstract }}
                    <span class="view_all" style="" @click="show_all(index)"
                      >收起</span
                    ></span
                  >
                  <span v-else>
                    <span v-if="item.abstract.length < 240">{{
                      item.abstract
                    }}</span>
                    <span v-else
                      >{{ item.abstract.slice(0, 240) }} <span>...</span
                      ><span class="view_all" style="" @click="show_all(index)"
                        >全部</span
                      ></span
                    >
                  </span>
                </div>
                <div class="abstract_css" v-if="item.ch_abstract">
                  <span style="font-weight: 600; font-size: 16px">翻译: </span>
                  <span v-if="item.abstract_show_ch"
                    >{{ item.ch_abstract }}
                    <span class="view_all" style="" @click="show_all_ch(index)"
                      >收起</span
                    ></span
                  >
                  <span v-else>
                    <span v-if="item.ch_abstract.length < 240">{{
                      item.ch_abstract
                    }}</span>
                    <span v-else
                      >{{ item.ch_abstract.slice(0, 240) }} <span>...</span
                      ><span
                        class="view_all"
                        style=""
                        @click="show_all_ch(index)"
                        >全部</span
                      ></span
                    >
                  </span>
                </div>
                <div class="list_bottom">
                  <span class="fraction_">
                    <span v-if="item._score && item._score != '0'">{{
                      item._score
                    }}</span>
                  </span>
                  <div class="function_list">
                    <div
                      v-if="item.article"
                      @click="
                        viewSimilar(
                          item.article[0].ids_distances.length,
                          item.article[0].unique_id,
                          index
                        )
                      "
                    >
                      <img src="@/assets/img/same.png" />
                      相似段落
                    </div>
                    <div @click="search_img(item.abstract, item.ch_abstract)">
                      <img src="@/assets/img/相似似.png" />
                      相似文献
                    </div>
                    <div v-if="item.article_link">
                      <img src="@/assets/img/查看 (3).png" />
                      <a :href="item.article_link" target="_blank">查看详情</a>
                    </div>
                  </div>
                </div>
                <el-collapse-transition>
                  <div v-show="item.sameShow">
                    <div
                      v-loading="sameloadIndex == index ? sameload : false"
                      element-loading-text="加载中..."
                      element-loading-spinner="el-icon-loading"
                      class="same_p"
                      v-if="item.article"
                    >
                      <ul>
                        <li v-for="(ele, i) in item.similarList" :key="i">
                          <div style="word-break: break-all">
                            <span class="s_tit">相似段落：</span>
                            {{ ele.content }}
                          </div>
                          <div>
                            <span class="s_tit">位置：</span>{{ ele.page }} 页
                          </div>
                          <div class="s_bot">
                            <span
                              ><span class="s_tit">相似度：</span
                              >{{ ele.distances }}</span
                            >
                            <span
                              style="
                                color: #e6a23c;
                                cursor: pointer;
                                text-align: center;
                                width: 130px;
                                margin: 0;
                              "
                            >
                              <!-- <img src="@/assets/img/相似似.png" width="18px" style="vertical-align: middle;"> -->
                              <span
                                style="width: 60px; margin-right: 10px"
                                @click="searchSimilarLiterature(ele.content)"
                                >相似文献</span
                              >
                              <span
                                style="width: 60px; margin-right: 0"
                                @click="
                                  viewOriginalText(ele.unique_id, ele.page)
                                "
                              >
                                查看原文
                              </span>
                            </span>
                          </div>
                        </li>
                      </ul>
                      <div class="view_all_s">
                        <div
                          class="view_item"
                          v-if="
                            item.showAllSame && item.completeList.length > 3
                          "
                          @click="viewWholeSimilar(index)"
                        >
                          <i class="el-icon-caret-bottom"></i>查看全部
                        </div>
                        <div
                          class="view_item"
                          v-if="
                            !item.showAllSame && item.completeList.length > 3
                          "
                          @click="upWhole(index)"
                        >
                          <i class="el-icon-caret-top"></i>收起
                        </div>
                      </div>
                    </div>
                  </div>
                </el-collapse-transition>
              </div>
            </div>
            <!-- 按段落显示 -->
            <div v-else>
              <div
                class="data_txt paragraph_order"
                v-for="(item, index) in list_data"
                :key="index"
              >
                <div
                  style="line-height: 25px; font-size: 15px; margin-right: 5px"
                >
                  {{ (cqu.page - 1) * 10 + index + 1 }}.
                </div>
                <div>
                  <p v-if="item.content" style="line-height: 25px">
                    <span style="font-size: 15px">相似段落：</span>
                    <span style="word-break: break-all">{{
                      item.content
                    }}</span>
                  </p>
                  <p v-if="item.page" style="line-height: 25px">
                    <span style="font-size: 15px">位置：</span>
                    <span>{{ item.page }}页</span>
                  </p>
                  <!-- v-if="item.title" -->
                  <p style="line-height: 25px">
                    <span style="font-size: 16px; font-weight: 700 !important"
                      >来自：</span
                    >
                    <span
                      style="font-size: 15px; font-weight: 700 !important"
                      >{{ item._source.title }}</span
                    >
                  </p>
                  <div class="other_detail">
                    <!-- v-if="item.author && item.author.length > 0" -->
                    <span
                      v-if="
                        item._source.author && item._source.author.length > 0
                      "
                      class="other_detail_item"
                    >
                      <span class="item_title">作者：</span
                      ><span
                        v-for="(item_aut, index_) in item._source.author"
                        :key="index_"
                      >
                        {{ item_aut }}
                        <span v-if="index_ + 1 < item._source.author.length">
                          ;
                        </span>
                      </span>
                    </span>
                    <span
                      v-if="
                        item._source.author && item._source.author.length > 0
                      "
                      class="segmentation_line"
                    ></span>
                    <!-- v-if="item.keyword && item.keyword.length > 0" -->
                    <span
                      v-if="
                        item._source.keyword && item._source.keyword.length > 0
                      "
                      class="other_detail_item"
                    >
                      <span class="item_title">关键词：</span>
                      <span
                        v-for="(key, index_) in item._source.keyword"
                        :key="index_"
                      >
                        {{ key }}
                        <span v-if="index_ + 1 < item._source.keyword.length">
                          ;
                        </span>
                      </span>
                    </span>
                    <span
                      v-if="
                        item._source.keyword && item._source.keyword.length > 0
                      "
                      class="segmentation_line"
                    ></span>
                    <!--  v-if="item.year" -->
                    <span v-if="item._source.year" class="other_detail_item">
                      <span class="item_title">年份：</span>
                      {{ item._source.year }}
                    </span>
                    <span
                      v-if="item._source.year && item._source.doi"
                      class="segmentation_line"
                    ></span>
                    
                    <!-- v-if="item.doi"  -->
                    <span
                      v-if="item._source.doi"
                      class="other_detail_item"
                      @click="doi_url(item._source.doi)"
                    >
                      <span class="item_title">DOI：</span>
                      <span class="doi_css">
                        {{ item._source.doi }}
                        <i class="el-icon-top-right"></i>
                      </span>
                    </span>
                    <span class="segmentation_line" v-if="item._source.source"></span>
                    <span v-if="item._source.source" class="other_detail_item">
                      <span class="item_title">来源：</span>
                      {{ item._source.source }}
                    </span>
                  </div>
                  <div class="list_bottom">
                    <span class="fraction_">{{ item.distances }}</span>
                    <div class="function_list">
                      <div @click="viewOriginalText(item.unique_id, item.page)">
                        <img src="@/assets/img/查看 (3).png" />
                        查看原文
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div v-if="total > cqu.size" class="pag_s">
            <!-- total,sizes,prev, pager, next,jyiumper -->
            <span style="display: inline-block; padding: 37px 0px 0px"
              >{{ total }} 条</span
            >
            <el-pagination
              style="padding: 30px 0px 0 0"
              background
              layout="prev, pager, next"
              :total="total > 10000 ? 10000 : total"
              :page-sizes="[10, 20]"
              :page-size="cqu.size"
              @size-change="handleSizeChange"
              :current-page.sync="cqu.page"
              @current-change="handleCurrentChange"
            ></el-pagination>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
  
<script>
import { journalFellowApi, fellowSimilarApi1 } from "@/api/classify";
import comHeader from "@/components/ComHeader.vue";
import store from "@/store";
export default {
  components: { comHeader },
  data() {
    return {
      textarea: "",
      year_s: [],
      keyword_s: [],
      author_s: [],
      searchType: "1",
      cqu: {
        page: 1,
        size: 10,
        year: [],
        author: [],
        content: "",
        show_type: "",
        keyword: [],
        article_content: "",
      },
      list_data: [],
      total: 0,
      loading: false,
      // sift_orr: true,
      organ_name: "",
      active: 9,
      radio: "1",
      value: "ChatArchives",
      sameShow: false,
      similarList: [], //相似段落列表
      sameload: false,
      sameloadIndex: 0,
      corpus_or: false,
      corpus_list: [],
      corpus_val: [],
    };
  },
  created() {
    if (this.$route.query.radio) {
      this.radio = this.$route.query.radio;
    }
    console.log(this.radio);
    if (this.$route.query.cqu) {
      this.cqu = JSON.parse(this.$route.query.cqu);
      console.log(this.cqu);
      if (this.cqu.content) {
        this.textarea = this.cqu.content;
      } else {
        this.searchType = this.cqu.show_type;
        this.textarea = this.cqu.article_content;
      }
      if (this.cqu.show_type) {
        this.searchType = this.cqu.show_type;
      } else {
        this.searchType = "1";
      }
      if (this.cqu.corpus_ids && this.cqu.corpus_ids.length > 0) {
        this.corpus_val = this.cqu.corpus_ids;
      } else {
        this.corpus_val = [];
      }
    }
    this.get_data();
    if (store.getCookie("organ_name")) {
      this.organ_name = store.getCookie("organ_name");
    }
    if (
      store.getCookie("organ_name") == "辽宁根谷智能科技服务有限公司" &&
      sessionStorage.getItem("corpus_s")
    ) {
      this.corpus_or = true;
      this.corpus_list = JSON.parse(sessionStorage.getItem("corpus_s"));
      // // this.corpus_val = this.corpus_list[0].code;
      // console.log(this.corpus_list);
      // this.corpus_val = this.corpus_list.map((item) => item.code);
      // console.log(this.corpus_val.indexOf(this.corpus_val[0]));
    }
  },
  methods: {
    sift_all() {
      this.cqu.page = 1;
      this.get_data();
    },
    search_img(txt, chtxt) {
      if (txt !== "") {
        this.textarea = txt;
      } else {
        this.textarea = chtxt;
      }
      if (this.searchType === "1") {
        this.search("1");
      } else {
        this.search("2");
      }
    },
    retrievalData() {
      this.cqu = {
        page: 1,
        size: 10,
        year: [],
        author: [],
        content: "",
        show_type: this.searchType,
        keyword: [],
        article_content: "",
        corpus_ids: this.corpus_val,
      };
      if (this.radio == "1") {
        this.cqu.content = this.textarea;
        this.cqu.article_content = "";
      } else {
        this.cqu.article_content = this.textarea;
        this.cqu.content = "";
      }
    },
    search(type, same) {
      if (same && this.textarea == "") {
        this.$message({
        message: this.$t("chatresearch.tips"),
          type: "warning",
        });
        return;
      } else {
        this.list_data = [];
        this.total = 0;
        if (type) {
          this.searchType = type;
          this.retrievalData();
        } else {
          this.retrievalData();
        }
        this.get_data();
      }
    },
    clearText() {
      this.textarea = "";
      if (this.searchType == "2") {
        this.searchType = "1";
      }
      this.search();
    },
    get_data() {
      this.loading = true;
      let cqu_copy = { ...this.cqu };
      journalFellowApi(cqu_copy)
        .then((res) => {
          if (res.data.code == 0) {
            if (this.searchType === "1") {
              // if (
              //     this.year_s.length < res.data.data.category.year.buckets.length
              // ) {
              this.year_s = res.data.data.category.year.buckets;
              // }
              // if (
              //     this.keyword_s.length <
              //     res.data.data.category.keyword.buckets.length
              // ) {
              this.keyword_s = res.data.data.category.keyword.buckets;
              // }
              // if (
              //     this.author_s.length <
              //     res.data.data.category.author.buckets.length
              // ) {
              this.author_s = res.data.data.category.author.buckets;
              // }
              res.data.data.list.forEach((item, index) => {
                item.abstract_show = false;
                item.abstract_show_ch = false;
                item.sameShow = false; //控制相似段落显示隐藏字段
                item.showAllSame = true; //控制相似段落显示隐藏字段(展开全部)
                item.similarList = []; //相似段落列表
                item.completeList = [];
              });
            }
            this.list_data = res.data.data.list;
            this.total = res.data.data.total;
            this.loading = false;
            console.log(this.list_data);
            this.$router.push({
              path: "/chatArchivesList",
              query: {
                cqu: JSON.stringify(this.cqu),
                radio: this.radio,
              },
            });
          } else {
            this.loading = false;
          }
        })
        .catch((err) => {
          this.loading = false;
          // this.sift_orr = true;
          // console.log(err); //直接捕获 new Promise  reject("rejected status")
        });
    },
    // 查看相似段落
    async viewSimilar(len, id, index) {
      if (this.list_data[index].sameShow === true) {
        this.upWhole(index);
        return;
      } else {
        this.sameloadIndex = index;
        this.list_data[index].sameShow = true;
        this.list_data[index].showAllSame = true;
        if (this.list_data[index].similarList.length > 0) {
          return;
        }
        this.sameload = true;
        const res = await fellowSimilarApi1({
          num: len,
          unique_id: id,
          article_content: this.cqu.article_content,
        });
        this.list_data[index].similarList = res.data.data.slice(0, 1);
        this.list_data[index].completeList = res.data.data;
        this.sameload = false;
        console.log(res);
      }
    },
    // 查看全部相似段落
    viewWholeSimilar(index) {
      // 页面渲染相似段落列表=全部相似段落列表
      this.list_data[index].similarList = this.list_data[index].completeList;
      this.list_data[index].showAllSame = false;
    },
    // 收起
    upWhole(i) {
      const box = document.querySelectorAll(".same_p");
      // 盒子的滚动条回到顶部
      box[i].scrollTop = 0;
      // 相似段落收起
      this.list_data[i].sameShow = false;
      // 相似段落展开显示展示全部
      this.list_data[i].showAllSame = true;
      // 相似段落列表最大高度设为200，防止渲染抖动
      // 相似段落列表长度截取三个
      setTimeout(() => {
        this.list_data[i].similarList = this.list_data[i].completeList.slice(
          0,
          1
        );
      }, 500);
    },
    // 相似文献
    searchSimilarLiterature(txt) {
      this.textarea = txt;
      if (this.searchType === "1") {
        this.search("1");
      } else {
        this.search("2");
      }
    },
    show_all(i) {
      this.list_data[i].abstract_show = !this.list_data[i].abstract_show;
    },
    show_all_ch(i) {
      this.list_data[i].abstract_show_ch = !this.list_data[i].abstract_show_ch;
    },
    handleSizeChange(val) {
      this.cqu.size = val;
      this.get_data();
    },
    handleCurrentChange(val) {
      this.cqu.page = val;
      this.get_data();
      const box = document.querySelector(".data_list");
      box.scrollTop = 0;
    },
    doi_url(url) {
      window.open("https://doi.org/" + url, "_blank");
    },
    // 查看原文
    viewOriginalText(id, page) {
      const { href } = this.$router.resolve({
        path: "/archivesDetail",
        query: {
          id: id,
          page: page,
          cqu: JSON.stringify(this.cqu),
          radio: this.radio,
        },
      });

      window.open(href, "_blank");
    },
  },
};
</script>
  
<style lang='less' scoped>
.ChatCQU_sci {
  height: 100vh;
  position: relative;
  //   padding: 20px 0;
  // background-image: url("../../assets/img/背景图/小助手-05(1).jpg");
  background-size: cover;
  background-position: center center;
}

.ChatCQU_sci {
  // padding: 20px 0 0 0 ;
  // // width: 100%; height: 100vh;
  // background: url("../../assets/img/背景图/小助手-05(1).jpg")  no-repeat;
  // background-size: 100% 100%;
  // background-attachment: fixed;
}

.box {
  margin: 25px auto;
  width: 80%;
  max-width: 1500px;

  .chat_s {
    // text-align: center;
    // text-align: left;
    // line-height: 50px;
    // position: relative;
    display: flex;
    justify-content: flex-end;
    align-items: center;
    flex-wrap: wrap;
    // flex-shrink: 0;
    margin: 10px 0 10px 0;

    .skip_host {
      display: inline-block;
      padding: 10px 30px 10px 30px;
      color: #444547;
      font-weight: 600;
      font-size: 20px;
    }

    .skip_sub {
      display: inline-block;
      //   width: 180px;
      padding: 10px 20px 10px 20px;
      font-size: 15px;
      font-weight: 500;
      letter-spacing: 0px;
      color: #909399;
      // line-height: 20px;
    }

    .skip_sub:hover {
      cursor: pointer;
      color: #444547;
      font-weight: 600;
    }
  }
}

.main_body {
  // padding: 20px;
  margin: 20px;
  margin-top: 0;
  display: flex;
  justify-content: space-between;

  // height: calc(100vh - 150px);
  // height: 420px;
  .main_left::-webkit-scrollbar {
    display: none;
  }

  .main_left {
    width: 33%;
    // margin: 0 10px 0 0;
    background: white;
    border-radius: 10px;
    padding: 10px;
    height: calc(100vh - 100px);
    overflow-x: hidden;
    overflow-y: scroll;

    .search_type {
      margin: 10px 0;
      text-align: left;
      display: flex;
      justify-content: space-between;
      align-items: center;

      /deep/ .el-radio__input.is-checked + .el-radio__label {
        color: #e6a23c;
      }

      /deep/ .el-radio__input.is-checked .el-radio__inner {
        border-color: #e6a23c;
        background: #e6a23c;
      }

      /deep/ .el-button {
        padding: 0;
        cursor: pointer;
        color: #2c3e50;
      }
    }
  }

  .main_right {
    width: 66%;
    // margin: 0 0px 0 10px;
    background: white;
    border-radius: 10px;
    //   padding: 10px;
  }
}

.main_left {
  .main_tit {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin: 0 0 10px 0;
  }
  h2 {
    display: inline-block;
    text-align: left;
    // line-height: 35px;
    color: #444547;
    font-weight: 800;
    font-size: 16px;
    letter-spacing: 1px;
    position: relative;
    top: 5px;
  }
}

.submit_css {
  width: 100%;
  margin: 10px 0;

  /deep/ span {
    font-weight: 600;
    letter-spacing: 10px;
    font-size: 16px;
  }
}

.sift_s::-webkit-scrollbar {
  // display: none;
}

.sift_s {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;

  // height: 420px;
  // overflow-x: hidden;
  // overflow-y: scroll;
  .sift_box {
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.12), 0 0 6px rgba(0, 0, 0, 0.04);
    border-radius: 10px;
    margin: 10px 0;
    width: 49%;

    // height: 30%;
    h3 {
      background-color: #e6a23c;
      text-align: left;
      letter-spacing: 3px;
      line-height: 30px;
      font-weight: 600;
      color: white;
      padding: 0 10px;
      border-start-start-radius: 10px;
      border-start-end-radius: 10px;
      cursor: pointer;
    }

    .sift_tit {
      background-color: #e6a23c;
      text-align: left;
      letter-spacing: 3px;

      color: white;
      padding: 0 10px;
      border-start-start-radius: 10px;
      border-start-end-radius: 10px;
      cursor: pointer;
      display: flex;
      justify-content: space-between;
      align-items: center;

      .tit {
        font-weight: 600;
        line-height: 40px;
        font-size: 16px;
      }

      .sub {
        padding: 5px 10px 5px 12px;
        font-size: 10px;
        border: 1px solid #ffffff;
        border-radius: 15px;
        display: inline-block;
      }

      .sub:hover {
        background: #fdf6ec;
        border: 1px solid #f5dab1;
        color: #e6a23c;
      }
    }

    .sift_list::-webkit-scrollbar {
      // display: none;
      width: 5px;
    }

    .sift_list::-webkit-scrollbar-thumb {
      border-radius: 10px;
      box-shadow: inset 0 0 5px rgba(0, 0, 0, 0);
      background: rgba(0, 0, 0, 0);
    }

    .sift_list::-webkit-scrollbar-track {
      box-shadow: inset 0 0 5px rgba(0, 0, 0, 0);
      border-radius: 0;
      background: rgba(190, 235, 231, 0);
    }

    .sift_list {
      height: 200px;
      // min-height: 200px;
      // max-height: 240px;
      width: 100%;
      overflow-x: hidden;
      overflow-y: auto;
      border-end-start-radius: 10px;
      border-end-end-radius: 10px;
      .el-checkbox {
        display: flex;
        align-content: center;
        margin: 10px;

        /deep/ .el-checkbox__input {
          white-space: nowrap;
          cursor: pointer;
          outline: none;
          display: inline-block;
          line-height: 1;
          position: relative;
          vertical-align: middle;
        }

        /deep/ .el-checkbox__inner {
          display: inline-block;
          position: relative;
          top: 2px;
        }

        /deep/ .el-checkbox__original {
          opacity: 0;
          outline: 0;
          position: absolute !important;
          margin: 0;
          width: 0 !important;
          height: 0 !important;
          z-index: -1;
        }

        /deep/ .el-checkbox__label {
          white-space: nowrap; //文本强制不换行；
          text-overflow: ellipsis; //文本溢出显示省略号；
          overflow: hidden; //溢出的部分隐藏；
        }
      }
    }

    .sift_list:hover::-webkit-scrollbar-thumb {
      border-radius: 10px;
      box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
      background: rgba(0, 0, 0, 0.2);
    }

    .sift_list:hover::-webkit-scrollbar-track {
      box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
      border-radius: 0;
      background: rgba(190, 235, 231, 0.1);
    }
  }
}

.main_right {
  text-align: left;

  .data_list {
    overflow: auto;
    // margin-right: 5px;
    padding: 10px;
    margin-top: 5px;
  }

  .data_list:hover::-webkit-scrollbar-thumb {
    border-radius: 10px;
    box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
    background: rgba(0, 0, 0, 0.2) !important;
  }

  .data_list:hover::-webkit-scrollbar-track {
    box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
    border-radius: 0;
    background: rgba(190, 235, 231, 0.1) !important;
  }

  .data_list::-webkit-scrollbar {
    // display: none;\
    width: 5px;
  }

  .data_list::-webkit-scrollbar-thumb {
    border-radius: 10px;
    box-shadow: inset 0 0 5px rgba(0, 0, 0, 0);
    background: transparent;
  }

  .data_list::-webkit-scrollbar-track {
    box-shadow: inset 0 0 5px rgba(0, 0, 0, 0);
    border-radius: 0;
    background: transparent;
  }

  .data_list {
    max-height: calc(100vh - 200px);
    overflow-x: hidden;
    //   overflow-y: scroll;

    .data_txt {
      margin: 0 0 10px 0;
      border: 1px rgb(117, 117, 117) solid;
      border-radius: 5px;
      padding: 10px;

      .txt_top {
        display: flex;
        align-items: center;
        justify-content: space-between;

        .txt_s {
          width: 100%;

          h3 {
            font-size: 16px;
            letter-spacing: 1px;
            line-height: 22px;
            margin: 0 0 5px 0;
            color: #000000;
            font-weight: 600;
          }

          p {
            line-height: 20px;
            margin: 0 0 10px 0;
            color: #5a5a5a;
          }
        }

        .img_s {
          width: 95px;
          cursor: pointer;

          img {
            // width: 80px;
            width: 55px;
            margin: 0 20px;
          }
        }
      }

      .abstract_css {
        line-height: 25px;
      }

      // 其他信息
      .other_detail {
        margin: 15px 0;
        // display: flex;
        // align-items: center;
        line-height: 25px;

        .other_detail_item {
          font-size: 14px;
          color: #535d71;

          .item_title {
            font-weight: 600;
          }
        }

        .segmentation_line {
          display: inline-block;
          height: 10px;
          border-left: 1px solid #535d71;
          margin: 0 10px;
        }
      }
    }
    .paragraph_order {
      display: flex;
      align-items: flex-start;
    }
  }

  .pag_s::-webkit-scrollbar {
    display: none;
  }

  .pag_s {
    display: flex;
    justify-content: center;
    width: 100%;
    overflow-x: scroll;
    overflow-y: hidden;
  }

  /deep/ .el-pagination.is-background .el-pager li:not(.disabled).active {
    background: #e6a23c;
  }

  .showType_ {
    text-align: right;
    // margin-right: 10px;
    margin-bottom: 10px;

    span {
      cursor: pointer;
    }
  }
}

.view_all {
  margin: 0 0 0 10px;
  font-weight: 600;
  cursor: pointer;
}

.view_all:hover {
  color: #409eff;
}

.img_txt {
  color: #a21e1e;
  font-size: 15px;
  // letter-spacing: 5px;
  font-weight: 600;
  text-align: center;
  line-height: 25px;
}

.list_bottom {
  // margin: 10px 0;
  margin-bottom: 5px;
  line-height: 30px;
  cursor: pointer;
  display: flex;
  justify-content: space-between;

  .function_list {
    display: flex;

    img {
      vertical-align: middle;
      width: 22px;
      margin-right: 3px;
    }

    div {
      margin: 0 10px;
    }
  }
}

.same_p {
  min-height: 100px;
  line-height: 20px;
  overflow: auto;

  ul {
    li {
      margin-bottom: 20px;
    }
  }

  .s_tit {
    font-weight: 600;
  }

  div {
    margin-bottom: 5px;
  }

  .s_bot {
    display: flex;
    justify-content: space-between;

    .s_distances {
      font-weight: 600;
      color: #8b1a1a;
    }
  }

  .view_all_s {
    .view_item {
      text-align: center;
      cursor: pointer;
    }
  }
}

.same_p::-webkit-scrollbar {
  // display: none;\
  width: 5px;
}

.same_p::-webkit-scrollbar-thumb {
  border-radius: 10px;
  box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
  background: rgba(0, 0, 0, 0.2);
}

.same_p::-webkit-scrollbar-track {
  box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
  border-radius: 0;
  background: rgba(190, 235, 231, 0.1);
}

.fraction_ {
  display: inline-block;
  color: #8b1a1a;
  font-weight: 600;
  font-size: 20px;
}

.cite {
  display: inline-block;
  display: inline-block;
  line-height: 30px;
  position: relative;
  top: -2px;
  cursor: pointer;
}
/deep/ .el-checkbox__label {
  width: calc(100% - 14px);
}
.tooltip_span {
  display: inline-block;
  width: 100%;
  display: flex;
  justify-content: space-between;
  .main {
    text-align: left;
    margin-right: 5px;
    width: 80%;
    white-space: nowrap; //文本强制不换行；
    text-overflow: ellipsis; //文本溢出显示省略号；
    overflow: hidden; //溢出的部分隐藏；
  }
}

.copy {
  display: flex;
  justify-content: center;
  align-items: center;

  .copy_input {
    min-width: 60%;
    border-radius: 4px;
    border: 1px solid #dcdfe6;
    background-color: #f5f7fa;
    border-color: #e4e7ed;
    color: #c0c4cc;
    min-height: 40px;
    line-height: 40px;
    outline: none;
    padding: 0 15px;
  }

  .el-icon-document-copy {
    margin: 0 0 0 10px;
    font-size: 20px;
  }

  .el-icon-document-copy:hover {
    cursor: pointer;
    color: #409eff;
  }
}

.slogan_ {
  // float: right;
  // display: inline-block;
  // justify-content: end;
  // width: 100%;
  // text-align: right;
  margin: 0 20px;
  color: #444547;
  font-weight: 600;
  // line-height: 40px;
  font-size: 15px;

  // position: absolute;
  // right: 10px;
  .slogan_sub {
    // display: inline-block;
    // // padding: 10px 30px 10px 30px;
    // color: #444547;
    // font-weight: 600;
    // line-height: 40px;
    // font-size: 18px;
  }
}

.doi_css {
  color: #007398;
  border-bottom: 1px solid #ffffff;
  cursor: pointer;
}

.doi_css:hover {
  color: #409eff;
  border-bottom: 1px solid #409eff;
}
.jour_s {
  // margin: 10px 0;
  /deep/ .el-input__inner {
    text-align: center;
  }
  /deep/ .el-tag__close {
    display: none !important; /* 隐藏删除按钮 */
  }
  /deep/ .el-select__tags-text {
    max-width: 60px;
    white-space: nowrap; //文本强制不换行；
    text-overflow: ellipsis; //文本溢出显示省略号；
    overflow: hidden; //溢出的部分隐藏；
  }
}
</style>